var API = "https://approval-dashboard.asikhwal.workers.dev";
var COMPANY = "company_RBFC";

function loadApproved() {
  fetch(API + "/get-approved?company=" + COMPANY)
    .then(function(res) { return res.json(); })
    .then(function(data) { renderApproved(data); })
    .catch(function() {
      document.getElementById("orders").innerHTML = "Error loading orders";
    });
}

function renderApproved(data) {
  var container = document.getElementById("orders");
  container.innerHTML = "";

  if (!data || data.length === 0) {
    container.innerHTML = "No approved orders";
    return;
  }

  data.forEach(function(item) {
    var o = item.node;

    var div = document.createElement("div");

    div.innerHTML =
      '<hr>' +
      '<strong>' + o.name + '</strong><br>' +
      'Customer: ' + (o.customer ? o.customer.email : '') + '<br>' +
      'Total: ' + (o.totalPriceSet ? o.totalPriceSet.shopMoney.amount : '') + '<br>' +
      '<span style="color:green;">Approved</span>';

    container.appendChild(div);
  });
}

loadApproved();